import { render, staticRenderFns } from "./ReachCasinoBetInfo.vue?vue&type=template&id=4ec4f2fa&scoped=true&"
import script from "./ReachCasinoBetInfo.vue?vue&type=script&lang=js&"
export * from "./ReachCasinoBetInfo.vue?vue&type=script&lang=js&"
import style0 from "./ReachCasinoBetInfo.vue?vue&type=style&index=0&id=4ec4f2fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec4f2fa",
  null
  
)

export default component.exports